import React from 'react';

import { Box, FlatListProps } from '@rbilabs/universal-components';
import { FlatList } from 'react-native';

import { IQuest } from '../loyalty-quest/types';
import { QuestCardWrapper } from '../quest-card-wrapper';
import { useUserQuest } from '../use-user-quest';

import { QuestCardListSkeleton } from './quest-card-list-skeleton';
import { QuestLibraryHeader } from './quest-library-header';

export const StepSeparator = Box.withConfig({
  height: '$4',
});

const listHeaderStyles: FlatListProps<IQuest>['ListHeaderComponentStyle'] = {
  alignItems: 'center',
  justifyContent: 'center',
};

const QuestCardList = ({ loyaltyId }: { loyaltyId: string }) => {
  const { isLoading, userQuest, cmsQuestCardUI } = useUserQuest({ loyaltyId });

  if (isLoading) {
    return <QuestCardListSkeleton />;
  }

  if (!userQuest || !cmsQuestCardUI) {
    return null;
  }

  return (
    <FlatList
      // For ReactNavigation the header will be displayed at the top of the page
      ListHeaderComponent={QuestLibraryHeader}
      ListHeaderComponentStyle={listHeaderStyles}
      data={[userQuest]}
      keyExtractor={({ loyaltyQuest }) => loyaltyQuest.id}
      ItemSeparatorComponent={StepSeparator}
      renderItem={({ item }) => {
        const { loyaltyQuest, cmsQuestCard } = item;

        return (
          <QuestCardWrapper
            quest={loyaltyQuest}
            cmsQuestCard={cmsQuestCard}
            cmsQuestCardUI={cmsQuestCardUI}
          />
        );
      }}
    />
  );
};

export default QuestCardList;
